import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class RoadmapTableIndexComponent extends Component {
  @service intl;
  @service store;
  @service('beta-toggle') betaService;

  @tracked sorts = [];

  checkboxSelectionMode = 'none';
  rowSelectionMode = 'none';
  widthConstraint = 'gte-container';
  enableReorder = true;

  @tracked columns = [
    {
      name: this.intl.t('dictionary.select'),
      valuePath: 'selected',
      class: '!w-[5%]',
      key: 'selected',
      component: 'roadmap/table/table-cell/toggle-initiative',
      isReorderable: false,
      isSortable: false,
    },
    {
      name: this.intl.t('_initiatives.title', {
        num: 2,
      }),
      valuePath: 'title',
      class: '!w-[10%]',
      key: 'title',
      isReorderable: true,
    },
    {
      name: this.intl.t('dictionary.eligible'),
      valuePath: 'recommended',
      class: '!w-[10%]',
      key: 'recommended',
      component: 'roadmap/table/table-cell/recommended/index',
      isReorderable: true,
    },
    {
      name: this.intl.t('_initiatives.source', {
        num: 1,
      }),
      valuePath: 'source',
      class: '!w-[10%]',
      key: 'source',
      isReorderable: true,
    },
    {
      name: this.intl.t('_initiatives.status'),
      valuePath: 'status',
      class: '!w-[10%]',
      key: 'status',
      isReorderable: true,
    },
    {
      name: this.intl.t('_initiatives.effort'),
      valuePath: 'person_weeks',
      class: '!w-[10%]',
      key: 'person_weeks',
      isReorderable: true,
    },
    {
      name: this.intl.t('_initiatives.uncertainty', {
        num: 1,
      }),
      valuePath: 'uncertainty',
      class: '!w-[10%]',
      key: 'uncertainty',
      isReorderable: true,
    },
    {
      name: this.intl.t('dictionary.impact'),
      valuePath: 'bon',
      class: '!w-[10%]',
      key: 'bon',
      isReorderable: true,
    },
  ];
}
